export default [
	'necessary',
	'statistics',
	'marketing',
]
